/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_TrainingInputs */

const en_page_title_training = /** @type {(inputs: Page_Title_TrainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training`)
};

const nl_page_title_training = /** @type {(inputs: Page_Title_TrainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training`)
};

/**
* | output |
* | --- |
* | "Training" |
*
* @param {Page_Title_TrainingInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const page_title_training = /** @type {((inputs?: Page_Title_TrainingInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_TrainingInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_page_title_training(inputs)
	return en_page_title_training(inputs)
});